module.exports = __webpack_public_path__ + "d2a705b59e370eaa5d145962f3b1ade1.ttf";